import Servers from './Servers'

export default [
  { path: '/servers', name: 'servers', component: Servers }
]



// WEBPACK FOOTER //
// ./src/components/servers/routes.js